import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
    TBFL2BackendRecord,
} from '../../../../../redux/app/bfl-2/@types';
import { IStore } from '../../../../../redux/store';
import authSelectors from '../../../../../redux/app/auth/selectors';
import BiofoulingPreviewer from './BiofoulingPreviewer';
import Biofouling2RecordParticipantsView from '../ParticipantsView';
import Biofouling2AttachmentsPrintView from '../BioAttachmentsPrintView';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
    biofoulingRecords: TBFL2BackendRecord[];
    isPrintVisible: boolean;
	vesselId: string;
};
type Biofouling2PrintProps = OwnProps & PropsFromRedux;
function Biofouling2Print(props: Biofouling2PrintProps) {
    const { isPrintVisible, biofoulingRecords } = props;
    if (!isPrintVisible) return null;
    return (
        <div className="w-full p-4">
            <div className="mb-8">
                <h3 className="w-3/4 mb-6 text-base font-medium leading-5 tracking-wide text-gray-600">
                    Biofouling Record Book
                </h3>
            </div>
            <div className="w-full bg-gray-100">
                <table className="w-full bg-gray-100 wayship-table-light orb4-table">
                    <thead>
                        <tr className="theader">
                            <th>
                                <div
                                    style={{ width: 100, textAlign: 'center' }}
                                    className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 border-gray-300 whitespace-nowrap"
                                >
                                    Date{' '}
                                </div>
                            </th>
                            <th>
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                    <p>Code</p>
                                    <p className="m-0">(Letter)</p>
                                </div>
                            </th>
                            <th>
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                    <p>Item</p>
                                    <p className="m-0">(number)</p>
                                </div>
                            </th>
                            <th>
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                    Record of operations/signature of officer in
                                    charge
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {biofoulingRecords.map((biofoulingRecord, index) => {
                            const isSubmitterChiefOrMaster =
                                biofoulingRecord.approvedBy
                                    ? biofoulingRecord.approvedBy.staffId ===
                                      biofoulingRecord.submittedBy?.staffId
                                    : false;
                            return (
                                <React.Fragment key={biofoulingRecord.id}>
                                    <BiofoulingPreviewer
                                        biofoulingRecord={biofoulingRecord}
                                        theme="light"
                                    />
                                    <Biofouling2AttachmentsPrintView
                                        biofoulingRecord={biofoulingRecord}
                                    />
                                    <Biofouling2RecordParticipantsView
                                        isSubmitterChiefOrMaster={
                                            isSubmitterChiefOrMaster
                                        }
                                        biofoulingRecord={biofoulingRecord}
                                    />
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
    return {
        vesselName: vesselInfo?.vesselName,
        imoNumber: vesselInfo?.imoNumber,
    };
}
const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Biofouling2Print);
